import * as React from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'

type VendorInformationVendorContactProps = {
  values: {
    contactResponsibilityDescription: string
    contactIsDecisionMaker: boolean
    contactReceivesRequestForProposals: boolean
  }
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onDecidingRoleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onReceiveRequestForProposalsChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const VendorInformationVendorContact: React.FC<VendorInformationVendorContactProps> = ({
  values,
  onChange,
  onDecidingRoleChange,
  onReceiveRequestForProposalsChange
}) => {
  const { t } = useTranslation()
  return (
    <>
      <Divider sx={{ mt: 1, mb: 2 }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gridGap: 16, px: 2 }}>
        <Typography variant="subtitle1">{t('your-role-in-company')}</Typography>
        <TextField
          name="contactResponsibilityDescription"
          label={t('my-responsibilities-eg-construction-in-helsinki-metropolitan-area')}
          variant="filled"
          onChange={onChange}
          value={values.contactResponsibilityDescription}
          sx={{ gridColumn: { xs: 'auto', sm: '1 / span 2' } }}
          fullWidth
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', px: 2, mt: 2 }}>
        <FormControlLabel
          control={<Checkbox checked={values.contactIsDecisionMaker} onChange={onDecidingRoleChange} />}
          label={t('i-am-a-decision-maker-in-this-company')}
          name="contactIsDecisionMaker"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={values.contactReceivesRequestForProposals}
              onChange={onReceiveRequestForProposalsChange}
            />
          }
          label={t('i-also-want-to-receive-request-for-proposals')}
          name="contactReceivesRequestForProposals"
        />
      </Box>
    </>
  )
}

export default VendorInformationVendorContact
